import styled from "styled-components";
import Color from "../../../../assets/styles/colors";

export const Container = styled.div``;

export const Row = styled.div``;

export const Col = styled.div``;

export const Div = styled.div``;

export const Header = styled.div`
  border-bottom: 1px solid
    ${(props) =>
      props.theme.isDarkTheme
        ? Color.textColorBlackFor
        : Color.textColorBlackSeven};
`;

export const HeaderTitle = styled.span`
  color: ${(props) =>
    props.theme.isDarkTheme ? Color.textColorBlackTree : "#232933"};
  font-size: 16px;
`;
